import { render } from "./HomeOptionsRestoreModal.vue?vue&type=template&id=353e553c&scoped=true&ts=true"
import script from "./HomeOptionsRestoreModal.vue?vue&type=script&lang=ts"
export * from "./HomeOptionsRestoreModal.vue?vue&type=script&lang=ts"

import "./HomeOptionsRestoreModal.vue?vue&type=style&index=0&id=353e553c&scoped=true&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-353e553c"]])

export default __exports__